import Value from './DomainSection'

export default {
	label: 'House domain',
	group: 'content',
	Value,
}
